(function(){
  'use strict';

  const initStickyInstance = (container) => {
    const sectionId = container?.dataset?.sectionId;
    if (!sectionId) return;

    const priceTarget = document.getElementById(`StickyATC-Price-${sectionId}`);
    const variantTarget = document.getElementById(`StickyATC-Variant-${sectionId}`);
    const button = document.getElementById(`StickyATC-Button-${sectionId}`);
    const submit = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const priceSource = document.getElementById(`price-${sectionId}`);
    const productInfo = document.getElementById(`ProductInfo-${sectionId}`);

    if (!submit || !productInfo) return;

    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    const updateStickyVisibility = () => {
      const rect = submit.getBoundingClientRect();
      const isAboveViewport = rect.bottom <= 0;
      if (isAboveViewport) {
        container.classList.remove('hidden');
      } else {
        container.classList.add('hidden');
      }
    };
    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });

    if (priceSource && priceTarget) {
      const copyPrice = () => {
        const clone = priceSource.cloneNode(true);
        clone.querySelectorAll('.price__badges, [class*="price__badge"]').forEach((el) => el.remove());
        priceTarget.innerHTML = clone.innerHTML;
      };
      copyPrice();
      const mo = new MutationObserver(copyPrice);
      mo.observe(priceSource, { subtree: true, childList: true, characterData: true });
    }

    const readSelectedOptions = () => {
      if (!productInfo) return '';
      const selections = [];
      const seenByKey = {};
      const variantInputs = productInfo.querySelectorAll('input[type="radio"][name*="-"]:checked, select[name*="-"]');
      variantInputs.forEach((input) => {
        if (input.type === 'radio' && input.checked) {
          const key = input.name || input.id || input.value;
          if (!seenByKey[key]) { selections.push(input.value); seenByKey[key] = true; }
        } else if (input.tagName === 'SELECT' && input.value) {
          const skey = input.name || input.id;
          if (!seenByKey[skey]) { selections.push(input.value); seenByKey[skey] = true; }
        }
      });
      const text = selections.filter(Boolean).join(' / ');
      if (!text || text.toLowerCase() === 'default title') return '';
      return text;
    };

    const updateVariantText = () => {
      if (!variantTarget) return;
      const text = readSelectedOptions();
      variantTarget.textContent = text;
    };

    updateVariantText();

    const syncButtonState = () => {
      if (!button || !submit) return;
      const isDisabled = submit.hasAttribute('disabled') || submit.disabled;
      if (isDisabled) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
      const labelSpan = submit.querySelector('span');
      if (labelSpan && labelSpan.textContent) {
        button.textContent = labelSpan.textContent.trim();
      }
    };
    syncButtonState();

    const submitObserver = new MutationObserver(syncButtonState);
    submitObserver.observe(submit, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });

    productInfo.addEventListener('change', (e) => {
      if (e.target && (e.target.name || '').includes('-')) { updateVariantText(); }
      syncButtonState();
    });
    const variantIdInput = productInfo.querySelector('.product-variant-id');
    if (variantIdInput) {
      const mo2 = new MutationObserver(updateVariantText);
      mo2.observe(variantIdInput, { attributes: true, attributeFilter: ['value', 'disabled'] });
    }

    document.addEventListener('variant:change', (e) => {
      const v = e && e.detail && (e.detail.variant || e.detail.selectedVariant);
      if (v && Array.isArray(v.options)) {
        const text = v.options.filter(Boolean).join(' / ');
        if (variantTarget) {
          variantTarget.textContent = (text && text.toLowerCase() !== 'default title') ? text : '';
        }
        syncButtonState();
      } else {
        updateVariantText();
        syncButtonState();
      }
    });
  };

  const initAll = () => {
    const containers = document.querySelectorAll('[id^="StickyATC-"]');
    containers.forEach((el) => initStickyInstance(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();


